export default __webpack_public_path__ + "media/src/assets/images/UserIcon-f82297124ca810ed0f09936c3b1ecace.svg";